import { Box, useMediaQuery } from '@mui/material';
import {
  IStyles,
  deserify,
  pxToRem,
  pxTovW,
  theme,
} from '@geneo2-web/shared-ui';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../reduxStore/reduxHooks';
import {
  ASSESSMENT_VIEW,
  HOMEWORK_PERFORMANCE,
} from '../../../../routeHandling/RoutesNomenclature';
import { StudentPerformanceGrid } from '../../../../components/StudentPerformanceGrid';
import { OverviewBox } from '../../../../components/OverviewBox';
import { AssessmentPageType } from '../../ClickerAssessmentManage';
import { useDownloadContext } from '../../../../app/Context/DownloadContextProviderV2';
import { interactionEvent } from '../../../Auth/auth.events';

const styles: IStyles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(20), md: pxTovW(34) },
  },
};

interface IProps {
  pageType: AssessmentPageType;
}

export const CAOngoingHwRightPanel = (props: IProps) => {
  const { pageType } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();
  const { current_assessmemt_classStats } = deserify(
    useAppSelector((state) => state.manageHomework)
  );
  const { clicker_assessment_info } = deserify(
    useAppSelector((state) => state.clickerAssessment)
  );

  const cardOnClick = (studentId: string) => {
    const attemptNumber =
      clicker_assessment_info?.selected_attempt?.attemptNumber;
    const queryParams = new URLSearchParams();
    if (attemptNumber !== undefined) {
      queryParams.append('attemptNumber', String(attemptNumber));
    }
    const queryString = queryParams.toString();
    const path = `${HOMEWORK_PERFORMANCE}/${studentId}${
      queryString ? `?${queryString}` : ''
    }`;
    navigate(path);
  };

  return (
    <Box sx={styles.root}>
      {!isMobile && (
        // it will be visible in left panel in Mobile device
        <OverviewBox
          assessmentTargetDate={
            current_assessmemt_classStats?.assessment?.assessmentTargetDate
          }
          difficultyLevel={
            current_assessmemt_classStats?.assessment?.difficultyLevel
          }
          numberOfQuestions={
            current_assessmemt_classStats?.assessment?.assessmentContentInfo
              ?.numberOfQuestions
          }
          viewAssessmentCTA={async () => {
            navigate(`${ASSESSMENT_VIEW}/assigned`);
            await interactionEvent({
              context: 'Test_Overview',
              name: 'VIEW_ASSESSMENT',
              pathSegments: pathSegments,
              isOffline: isOffline,
            });
          }}
        />
      )}

      <StudentPerformanceGrid
        className={`${current_assessmemt_classStats?.assessment?.class}${current_assessmemt_classStats?.assessment?.section}`}
        studentPerformanceInfoList={
          current_assessmemt_classStats?.studentPerformanceInfo
        }
        cardMaxMarks={current_assessmemt_classStats?.assessment?.maxMarks}
        cardSubmissionType={
          current_assessmemt_classStats?.assessment?.submissionType
        }
        cardOnClickHandler={cardOnClick}
        statusInfo={clicker_assessment_info?.statusInfo}
        pageType={pageType}
        assignedStudentCount={
          current_assessmemt_classStats?.assignedStudentsCount
        }
        studentSubmissionCount={
          current_assessmemt_classStats?.studentsSubmissionCount
        }
      />
    </Box>
  );
};
